import UserEntityMemberInvitation from "legal-entities/invitations/member-invitations/email-based/user-entity-member-invitation";
import Guid from "_shared/guids/guid";

export default class CreateUserEntityMemberInvitationAPIRequest {
  public readonly inviteeEmail: string;
  public readonly firstName?: string;
  public readonly lastName?: string;
  public readonly accessTemplateId?: string;

  public constructor(invitation: UserEntityMemberInvitation, accessTemplateId?: Guid) {
    if (!invitation.registrationInfo?.email) {
      throw new Error("Registration info email is required to create an Entity Member Invitation.");
    }

    this.inviteeEmail = invitation.registrationInfo.email.value;
    this.firstName = invitation.registrationInfo.name?.firstName;
    this.lastName = invitation.registrationInfo.name?.lastName;
    this.accessTemplateId = accessTemplateId?.value;
  }
}
